//#region src/web/config.ts
const AI_CLOUD_ROLE = "ux-my-prescryptive";
const defaultConfig = {
	enableAutoRouteTracking: true,
	enableCorsCorrelation: true,
	enableRequestHeaderTracking: true,
	enableResponseHeaderTracking: true,
	enableUnhandledPromiseRejectionTracking: true,
	correlationHeaderExcludedDomains: ["launchdarkly.com"]
};

//#endregion
export { AI_CLOUD_ROLE, defaultConfig };